import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import "bootstrap-icons/font/bootstrap-icons.css";

ReactDOM.render(<App />, document.getElementById('root'));